import { generatePath, Link } from 'react-router-dom';

import type { Site } from '@/project-management/entities/site';
import type { Workstream } from '@/project-management/entities/workstream';
import { WorkstreamsQuery } from '@/project-management/queries/workstreams.query';

import { WorkstreamPreview } from './workstream-preview';

export type SideCardProps = {
  site: Pick<Site, 'id' | 'name'> & {
    workstreams: Pick<Workstream, 'id' | 'name' | 'progress' | 'endDate'>[];
  };
};

export function SiteCard({ site }: SideCardProps) {
  const prefetchWorkstreams = WorkstreamsQuery.usePrefetch();

  return (
    <Link
      to={generatePath('/asset/:id/project', site)}
      className="w-full cursor-pointer rounded-lg bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
      onMouseEnter={() => prefetchWorkstreams({ siteId: site.id })}
    >
      <div className="space-y-6">
        <h3 className="text-lg font-semibold text-gray-900">{site.name}</h3>
        {site.workstreams.length > 0 ? (
          <div className="space-y-2">
            {site.workstreams.map((workstream) => (
              <WorkstreamPreview key={workstream.id} workstream={workstream} />
            ))}
          </div>
        ) : (
          <div>
            <p className="text-sm italic text-gray-500">No workstreams</p>
          </div>
        )}
      </div>
    </Link>
  );
}
